import React from 'react';
import T from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  changeInput,
  resetFormState,
  setSelectedDraftScheduleStep,
} from '@dmi/shared/redux/Payments/FlexDraft/actions';
import { selectForm } from '@dmi/shared/redux/Payments/FlexDraft/selectors';

import { ScheduleSelect as ScheduleSelectComponent }
from '../../../../components/Payments/FlexDraft/EditSchedule';

const ScheduleSelect = ({
  dispatchChangeInput,
  dispatchResetFormState,
  dispatchSetSelectedDraftScheduleStep,
  formValues,
  navigation,
}) => (
  <ScheduleSelectComponent
    dispatchChangeInput={dispatchChangeInput}
    dispatchResetFormState={dispatchResetFormState}
    dispatchSetSelectedDraftScheduleStep={dispatchSetSelectedDraftScheduleStep}
    formValues={formValues}
    navigation={navigation}
  />
);

ScheduleSelect.propTypes = {
  dispatchChangeInput: T.func.isRequired,
  dispatchResetFormState: T.func.isRequired,
  dispatchSetSelectedDraftScheduleStep: T.func.isRequired,
  formValues: T.object.isRequired,
  navigation: T.object.isRequired,
};

const mapStateToProps = createStructuredSelector({ formValues: selectForm('scheduleSelect') });

const mapDispatchToProps = (dispatch) => ({
  dispatchChangeInput: (payload) => dispatch(changeInput(payload)),
  dispatchResetFormState: (payload) => dispatch(resetFormState(payload)),
  dispatchSetSelectedDraftScheduleStep: ({ step }) =>
    dispatch(setSelectedDraftScheduleStep({ step })),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ScheduleSelect);
